import React, { useEffect, useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faUpload, faImage } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './CategoriasData.css'
import 'jspdf-autotable';
import baseURL from '../../url';
import NewCategoria from '../NewCategoria/NewCategoria';
import { adminFetch } from '../../../utils/api';

export default function CategoriasData() {
    const [categorias, setCategoras] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [nuevaCategoria, setNuevaCategoria] = useState('');
    const [categoria, setCategoria] = useState({});
    
    // Descuentos
    const [discountOne, setDiscountOne] = useState(0);
    const [discountTwo, setDiscountTwo] = useState(0);
    const [discountThree, setDiscountThree] = useState(0);
    const [discountFour, setDiscountFour] = useState(0);
    
    // Imagen
    const [imagenFile, setImagenFile] = useState(null); 
    const [previewUrl, setPreviewUrl] = useState('');
    const fileInputRef = useRef(null);

    useEffect(() => {
        cargarCategoria();
    }, []);

    const cargarCategoria = () => {
        fetch(`${baseURL}/api/categorias`, { method: 'GET' })
            .then(response => response.json())
            .then(data => setCategoras(data.categorias || []))
            .catch(error => console.error('Error:', error));
    };

    const eliminarCategoria = (idCategoria) => {
        Swal.fire({
            title: '¿Eliminar Categoría?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                adminFetch(`${baseURL}/api/admin/categorias/${idCategoria}`, { method: 'DELETE' })
                    .then(response => response.json())
                    .then(data => {
                        if(data.mensaje) {
                            Swal.fire('¡Eliminado!', data.mensaje, 'success');
                            cargarCategoria();
                        } else {
                            toast.error(data.error);
                        }
                    })
                    .catch(error => toast.error("Error de conexión"));
            }
        });
    };

    const abrirModal = (item) => {
        setCategoria(item);
        setNuevaCategoria(item.categoria);
        setDiscountOne(item.discountOne);
        setDiscountTwo(item.discountTwo);
        setDiscountThree(item.discountThree);
        setDiscountFour(item.discountFour);
        
        // Imagen existente
        setPreviewUrl(item.imagen || '');
        setImagenFile(null); // Limpiar archivo nuevo

        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };

    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImagenFile(file);
            setPreviewUrl(URL.createObjectURL(file)); 
        }
    };

    const handleUpdateText = (idCategoria) => {
        const formData = new FormData();
        formData.append('categoria', nuevaCategoria !== '' ? nuevaCategoria : categoria.categoria);
        formData.append('discountOne', discountOne);
        formData.append('discountTwo', discountTwo);
        formData.append('discountThree', discountThree);
        formData.append('discountFour', discountFour);

        if (imagenFile) {
            formData.append('imagen', imagenFile);
        }

        adminFetch(`${baseURL}/api/admin/categorias/${idCategoria}`, {
            method: 'POST',
            body: formData,
        })
        .then(response => response.json())
        .then(data => {
            if (data.mensaje) {
                Swal.fire('¡Actualizado!', data.mensaje, 'success');
                cargarCategoria();
                cerrarModal();
            } else {
                Swal.fire('Error', data.error || "Error al actualizar", 'error');
            }
        })
        .catch(error => toast.error("Error de conexión: " + error.message));
    };

    return (
        <div>
            <ToastContainer />
            <div className='title-and-input'>
                <h2>Gestión de Categorías</h2>
                <NewCategoria cargarCategoria={cargarCategoria} />
            </div>

            {/* MODAL EDITAR (Misma estructura que Crear) */}
            {modalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <h3>Editar Categoría</h3>
                            <span className="close" onClick={cerrarModal}>&times;</span>
                        </div>

                        <div className='sectiontext'>
                            <div className='form-layout'>
                                
                                {/* TOP: Imagen + Nombre */}
                                <div className='top-section'>
                                    <div className='image-upload-wrapper'>
                                        <div className='preview-box' onClick={() => fileInputRef.current.click()}>
                                            {previewUrl ? (
                                                <img src={previewUrl} alt="Preview" className='img-preview-full' />
                                            ) : (
                                                <div className='no-image-placeholder'>Sin Imagen</div>
                                            )}
                                        </div>
                                        <input 
                                            type="file" 
                                            accept="image/*" 
                                            style={{display:'none'}} 
                                            ref={fileInputRef} 
                                            onChange={handleFileSelect} 
                                        />
                                        <button className='btn-select-file' onClick={() => fileInputRef.current.click()}>
                                            <FontAwesomeIcon icon={faUpload} /> Cambiar
                                        </button>
                                    </div>

                                    <div className='name-input-wrapper'>
                                        <label className='input-label'>Nombre de la Categoría</label>
                                        <input
                                            type="text"
                                            className='form-input-main'
                                            value={nuevaCategoria}
                                            onChange={(e) => setNuevaCategoria(e.target.value)}
                                        />
                                    </div>
                                </div>

                                {/* BOTTOM: Descuentos */}
                                <div className='discounts-section'>
                                    <span className='section-title'>Precios y Descuentos</span>
                                    <div className='grid-discounts'>
                                        <div className='discount-group'>
                                            <label>Desc. Nivel 1</label>
                                            <input type='number' value={discountOne} onChange={(e) => setDiscountOne(e.target.value)} />
                                        </div>
                                        <div className='discount-group'>
                                            <label>Desc. Nivel 2</label>
                                            <input type='number' value={discountTwo} onChange={(e) => setDiscountTwo(e.target.value)} />
                                        </div>
                                        <div className='discount-group'>
                                            <label>Desc. Nivel 3</label>
                                            <input type='number' value={discountThree} onChange={(e) => setDiscountThree(e.target.value)} />
                                        </div>
                                        <div className='discount-group'>
                                            <label>Desc. Nivel 4</label>
                                            <input type='number' value={discountFour} onChange={(e) => setDiscountFour(e.target.value)} />
                                        </div>
                                    </div>
                                </div>

                                <div className='modal-actions'>
                                    <button className='btn-cancel' onClick={cerrarModal}>Cancelar</button>
                                    <button className='btn-save' onClick={() => handleUpdateText(categoria.idCategoria)}>
                                        Guardar Cambios
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* TABLA */}
            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Imagen</th>
                            <th>Categoría</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {categorias.map(item => (
                            <tr key={item.idCategoria}>
                                <td data-label="ID">{item.idCategoria}</td>
                                <td data-label="Imagen">
                                    <img
                                        src={item.imagen}
                                        alt={item.categoria}
                                        style={{width: '50px', height: '50px', borderRadius: '5px', objectFit: 'cover'}}
                                        onError={(e) => e.target.src = 'https://via.placeholder.com/50?text=S/I'}
                                    />
                                </td>
                                <td data-label="Categoría">{item.categoria}</td>
                                <td data-label="Acciones" className="td-acciones">
                                    <div className="acciones-container">
                                        <button className='btn-eliminar' onClick={() => eliminarCategoria(item.idCategoria)}>
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                        <button className='btn-editar' onClick={() => abrirModal(item)}>
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}